<template>
  <div class="order-detail">
    <div class="detail-header">
      <el-button type="primary" size="small" circle @click="goBack">
        <i class="el-icon-back" />
      </el-button>
      <h2>订单详情</h2>
    </div>

    <!-- 基础信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>基础信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端表格 -->
        <div class="pc-table">
          <div class="info-grid">
            <div class="info-item">
              <span class="label">订单编号：</span>
              <span class="value">{{ orderDetail.orderNo || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">订单状态：</span>
              <span v-if="orderDetail.orderStatus == 2" class="value">{{
                warehouseStatusMap[orderDetail.warehouseStatus] || '-'
              }}</span>
              <span v-else class="value">{{
                orderStatusMap[orderDetail.orderStatus] || '-'
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">订单来源：</span>
              <span class="value">{{
                orderDetail.orderSource | orderSource
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">下单时间：</span>
              <span class="value">{{ orderDetail.orderTime || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">外部编号：</span>
              <span class="value">{{ orderDetail.externalNo || '暂无' }}</span>
            </div>
            <div class="info-item">
              <span class="label">客户：</span>
              <span class="value">{{ orderDetail.deliveryName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">联系方式：</span>
              <span class="value">{{
                orderDetail.deliveryContactNo || '-'
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">支付方式：</span>
              <span class="value">{{
                orderDetail.paymentMethod | paymentMethod
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">分销员：</span>
              <span class="value">{{ orderDetail.disUserName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">上级团长：</span>
              <span class="value">{{ orderDetail.leaderUserName || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">订单类型：</span>
              <span class="value">{{
                orderDetail.orderType | orderTypeFilter
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">订单备注：</span>
              <span class="value">{{ orderDetail.memo || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">订单合同：</span>
              <span
                class="value link"
                @click="viewContract"
              ><i class="el-icon-view" /> 查看</span>
            </div>
          </div>
        </div>

        <!-- 移动端卡片 -->
        <div class="mobile-card">
          <div class="card-item">
            <span class="label">订单编号</span>
            <span class="value">{{ orderDetail.orderNo || '' }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单状态</span>
            <span v-if="orderDetail.orderStatus == 2" class="value">{{
              warehouseStatusMap[orderDetail.warehouseStatus] || '-'
            }}</span>
            <span v-else class="value">{{
              orderStatusMap[orderDetail.orderStatus] || '-'
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单来源</span>
            <span class="value">{{
              orderDetail.orderSource | orderSource
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">下单时间</span>
            <span class="value">{{ orderDetail.orderTime || '' }}</span>
          </div>
          <div class="card-item">
            <span class="label">外部编号</span>
            <span class="value">{{ orderDetail.externalNo || '暂无' }}</span>
          </div>
          <div class="card-item">
            <span class="label">客户</span>
            <span class="value">{{ orderDetail.deliveryName || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">联系方式</span>
            <span class="value">{{
              orderDetail.deliveryContactNo || '-'
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">支付方式</span>
            <span class="value">{{
              orderDetail.paymentMethod | paymentMethod
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">分销员</span>
            <span class="value">{{ orderDetail.disUserName || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">上级团长</span>
            <span class="value">{{ orderDetail.leaderUserName || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单类型</span>
            <span class="value">{{
              orderDetail.orderType | orderTypeFilter
            }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单备注</span>
            <span class="value">{{ orderDetail.memo || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">订单合同</span>
            <span
              class="value link"
              @click="viewContract"
            ><i class="el-icon-view" /> 查看</span>
          </div>
        </div>
      </div>

      <!-- 商品列表 -->
      <div class="product-section">
        <h4>商品信息</h4>
        <!-- PC端商品表格 -->
        <div class="pc-product-table">
          <el-table :data="products" stripe size="small" class="product-table">
            <el-table-column
              prop="productImageUrl"
              label="商品图片"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <img
                  v-if="scope.row.productImageUrl"
                  :src="scope.row.productImageUrl"
                  alt="商品图片"
                  class="product-image"
                >
                <img
                  v-else
                  src="https://via.placeholder.com/60x60?text=商品"
                  alt="商品图片"
                  class="product-image"
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="productName"
              label="商品名称"
              min-width="150"
              align="center"
            />
            <el-table-column
              prop="productSkuAttrValue"
              label="规格/属性"
              min-width="100"
              align="center"
            />
            <el-table-column
              prop="productSkuBarCode"
              label="条形码"
              min-width="150"
              align="center"
            />
            <el-table-column
              prop="skuUnitPoint"
              label="单价 (元)"
              width="100"
              align="center"
            />
            <el-table-column
              prop="productUnit"
              label="数量"
              width="80"
              align="center"
            />
            <el-table-column
              prop="subtotal"
              label="小计"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  Number(scope.row.skuUnitPoint) * Number(scope.row.productUnit)
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 移动端商品卡片 -->
        <div class="mobile-product-cards">
          <div
            v-for="(product, index) in products"
            :key="index"
            class="mobile-product-card"
          >
            <div class="product-image-container">
              <img
                v-if="product.productImageUrl"
                :src="product.productImageUrl"
                alt="商品图片"
                class="mobile-product-image"
              >
              <img
                v-else
                src="https://via.placeholder.com/80x80?text=商品"
                alt="商品图片"
                class="mobile-product-image"
              >
            </div>
            <div class="product-info">
              <div class="product-name">{{ product.productName }}</div>
              <div class="product-spec">{{ product.productSkuAttrValue }}</div>
              <div class="product-barcode">
                条形码：{{ product.productSkuBarCode }}
              </div>
              <div class="product-price-row">
                <div class="product-price">
                  单价：{{ product.skuUnitPoint }}元
                </div>
                <div class="product-quantity">
                  数量：{{ product.productUnit }}
                </div>
                <div class="product-subtotal">
                  小计：{{
                    Number(product.skuUnitPoint) * Number(product.productUnit)
                  }}元
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 费用信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>费用信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端表格 -->
        <div class="pc-table">
          <!-- <div class="info-grid">
            <div class="info-item">
              <span class="label">开发票：</span>
              <span class="value">{{
                orderDetail.whetherToBill ? '是' : '否'
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">发票类型：</span>
              <span class="value">{{ orderDetail.invoiceType || '个人' }}</span>
            </div>
            <div class="info-item">
              <span class="label">发票抬头：</span>
              <span class="value">{{ orderDetail.invoiceTitle || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">手机号：</span>
              <span class="value">{{ orderDetail.invoicePhone || '' }}</span>
            </div>
            <div class="info-item">
              <span class="label">邮箱：</span>
              <span class="value">{{ orderDetail.invoiceEmail || '' }}</span>
            </div>
          </div> -->

          <div class="fee-section">
            <!-- <h4>费用明细</h4> -->
            <div class="fee-grid">
              <div class="fee-item">
                <span class="label">商品合计：</span>
                <span class="value">{{ orderDetail.actualAmount || '0' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">会员折扣：</span>
                <span
                  class="value"
                >- {{ orderDetail.memberDiscount || '0.00' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">运费：</span>
                <span class="value">{{
                  orderDetail.freightAmount || '0.00'
                }}</span>
              </div>
              <div class="fee-item">
                <span class="label">活动优惠：</span>
                <span class="value">- 0</span>
              </div>
              <div class="fee-item">
                <span class="label">其他费用：</span>
                <span class="value">0</span>
              </div>
              <div class="fee-item">
                <span class="label">优惠券：</span>
                <span
                  class="value"
                >- {{ orderDetail.couponDeductAmount || '0.00' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">押金：</span>
                <span class="value">{{ orderDetail.deposit || '0.00' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">红包抵扣：</span>
                <span class="value">- 0</span>
              </div>
              <div class="fee-item">
                <span class="label">定金：</span>
                <span class="value">{{
                  orderDetail.earnestMoney || '0.00'
                }}</span>
              </div>
              <div class="fee-item">
                <span class="label">积分抵扣：</span>
                <span
                  class="value"
                >- {{ orderDetail.integralDeductAmount || '0.00' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">尾款：</span>
                <span class="value">{{ orderDetail.debtMoney || '0.00' }}</span>
              </div>
              <div class="fee-item">
                <span class="label">储值支付：</span>
                <span class="value">{{
                  orderDetail.orderBalanceDeduct || '0.00'
                }}</span>
              </div>
              <div class="fee-item" style="display: none">
                <span class="label">购物金：</span>
                <span
                  class="value"
                >- {{ orderDetail.shoppingMoneyAmount || '0' }}</span>
              </div>
              <div class="fee-item" style="display: none">
                <span class="label">兑换卡：</span>
                <span
                  class="value"
                >- {{ orderDetail.redeemCardAmount || '0' }}</span>
              </div>
            </div>

            <!-- 总计 -->
            <div class="total-section">
              <div class="total-item">
                <span class="label">应收合计：</span>
                <span class="value">¥{{ totalReceivables || 0 }}</span>
              </div>
              <div class="total-item final">
                <span class="label">实收金额：</span>
                <span
                  class="value highlight"
                >¥{{ orderDetail.actualSumAmount || '0.00' }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 移动端费用卡片 -->
        <div class="mobile-card">
          <!-- <div class="card-item">
            <span class="label">开发票</span>
            <span class="value">{{ orderDetail.isInvoice || '否' }}</span>
          </div>
          <div class="card-item">
            <span class="label">发票类型</span>
            <span class="value">{{ orderDetail.invoiceType || '个人' }}</span>
          </div>
          <div class="card-item">
            <span class="label">发票抬头</span>
            <span class="value">{{ orderDetail.invoiceTitle || '' }}</span>
          </div>
          <div class="card-item">
            <span class="label">手机号</span>
            <span class="value">{{ orderDetail.invoicePhone || '' }}</span>
          </div>
          <div class="card-item">
            <span class="label">邮箱</span>
            <span class="value">{{ orderDetail.invoiceEmail || '' }}</span>
          </div> -->

          <div class="mobile-fee-section">
            <!-- <h4>费用明细</h4> -->
            <div class="mobile-fee-grid">
              <div class="mobile-fee-item">
                <span class="label">商品合计：</span>
                <span class="value">{{
                  orderDetail.actualAmount || '0.00'
                }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">会员折扣：</span>
                <span
                  class="value"
                >- {{ orderDetail.memberDiscount || '0.00' }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">运费：</span>
                <span class="value">{{
                  orderDetail.freightAmount || '0.00'
                }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">活动优惠：</span>
                <span class="value">- 0</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">其他费用：</span>
                <span class="value">0</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">优惠券：</span>
                <span
                  class="value"
                >- {{ orderDetail.couponDeductAmount || '0.00' }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">押金：</span>
                <span class="value">{{ orderDetail.deposit || '0.00' }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">红包抵扣：</span>
                <span class="value">- 0</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">定金：</span>
                <span class="value">{{
                  orderDetail.earnestMoney || '0.00'
                }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">积分抵扣：</span>
                <span
                  class="value"
                >- {{ orderDetail.integralDeductAmount || '0.00' }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">尾款：</span>
                <span class="value">{{ orderDetail.debtMoney || '0.00' }}</span>
              </div>
              <div class="mobile-fee-item">
                <span class="label">储值支付：</span>
                <span class="value">{{
                  orderDetail.orderBalanceDeduct || '0.00'
                }}</span>
              </div>
            </div>

            <!-- 移动端总计 -->
            <div class="mobile-total-section">
              <div class="mobile-total-item">
                <span class="label">应收合计：</span>
                <span class="value">¥{{ totalReceivables }}</span>
              </div>
              <div class="mobile-total-item final">
                <span class="label">实收金额：</span>
                <span
                  class="value highlight"
                >¥{{ orderDetail.actualSumAmount || '0.00' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 物流信息板块 -->
    <div class="section">
      <div class="section-header">
        <h3>物流信息</h3>
      </div>
      <div class="section-content">
        <!-- PC端物流表格 -->
        <div class="pc-table">
          <div class="info-grid">
            <div class="info-item">
              <span class="label">配送方式：</span>
              <span class="value">{{
                orderDetail.deliveryType == 1 ? '门店自提' : '配送'
              }}</span>
            </div>
            <div v-if="orderDetail.deliveryType == 2" class="info-item">
              <span class="label">自提地点地址：</span>
              <span
                class="value"
              >{{ orderDetail.pickupAddress || '-'
              }}{{ orderDetail.pickUpName || '' }}</span>
            </div>
            <div v-if="orderDetail.deliveryType == 1" class="info-item">
              <span class="label">包裹编号：</span>
              <span class="value">{{ orderDetail.packageNo || '-' }}</span>
            </div>
            <div v-if="orderDetail.deliveryType == 1" class="info-item">
              <span class="label">物流公司：</span>
              <span class="value">{{ orderDetail.courierName || '-' }}</span>
            </div>
            <div v-if="orderDetail.deliveryType == 1" class="info-item">
              <span class="label">物流单号：</span>
              <span class="value">{{ orderDetail.courierNo || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">发货时间：</span>
              <span class="value">{{ orderDetail.deliveryTime || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">自动确认收货时间：</span>
              <span class="value">{{
                orderDetail.autoConfirmTime || '-'
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">发货地址：</span>
              <span class="value">{{ orderDetail.wareAddress || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">仓库名称：</span>
              <span class="value">{{ orderDetail.wareName || '-' }}</span>
            </div>
          </div>

          <div class="consignee-section">
            <h4>收货人信息</h4>
            <div class="info-grid">
              <div class="info-item">
                <span class="label">收货人：</span>
                <span class="value">{{ orderDetail.deliveryName || '-' }}</span>
              </div>
              <div class="info-item">
                <span class="label">手机号：</span>
                <span class="value">{{
                  orderDetail.deliveryContactNo || '-'
                }}</span>
              </div>
              <div v-if="orderDetail.deliveryType == 1" class="info-item">
                <span class="label">收货地址：</span>
                <span class="value">{{
                  orderDetail.deliveryProvince +
                    orderDetail.deliveryCity +
                    orderDetail.deliveryArea +
                    orderDetail.deliveryStreet
                }}</span>
              </div>
            </div>
          </div>

          <!-- <div class="delivery-image-section">
            <h4>发货图片</h4>
            <div class="image-container">
              <div v-if="deliveryImages.length > 0" class="images-grid">
                <div
                  v-for="(image, index) in deliveryImages"
                  :key="index"
                  class="image-item"
                >
                  <img :src="image" alt="发货图片" class="delivery-image">
                </div>
              </div>
              <div v-else class="no-images">
                <div class="no-image-placeholder">暂无更多</div>
              </div>
            </div>
          </div> -->
        </div>

        <!-- 移动端物流卡片 -->
        <div class="mobile-card">
          <div class="card-item">
            <span class="label">配送方式</span>
            <span class="value">{{
              orderDetail.deliveryType == 1 ? '快递配送' : '门店自提'
            }}</span>
          </div>
          <div v-if="orderDetail.deliveryType == 2" class="card-item">
            <span class="label">自提地点地址</span>
            <span
              class="value"
            >{{ orderDetail.pickUpAddress || '-'
            }}{{ orderDetail.pickUpName || '' }}</span>
          </div>
          <div v-if="orderDetail.deliveryType == 1" class="card-item">
            <span class="label">包裹编号</span>
            <span class="value">无</span>
          </div>
          <div v-if="orderDetail.deliveryType == 1" class="card-item">
            <span class="label">物流公司</span>
            <span class="value">{{ orderDetail.courierName || '-' }}</span>
          </div>
          <div v-if="orderDetail.deliveryType == 1" class="card-item">
            <span class="label">物流单号</span>
            <span class="value">{{ orderDetail.courierNo || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">发货时间</span>
            <span class="value">{{ orderDetail.deliveryTime || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">自动确认收货时间</span>
            <span class="value">{{ orderDetail.autoConfirmTime || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">发货地址</span>
            <span class="value">{{ orderDetail.wareAddress || '-' }}</span>
          </div>
          <div class="card-item">
            <span class="label">仓库名称</span>
            <span class="value">{{ orderDetail.wareName || '-' }}</span>
          </div>

          <div class="mobile-consignee-section">
            <h4>收货人信息</h4>
            <div class="card-item">
              <span class="label">收货人</span>
              <span class="value">{{ orderDetail.deliveryName || '-' }}</span>
            </div>
            <div class="card-item">
              <span class="label">手机号</span>
              <span class="value">{{
                orderDetail.deliveryContactNo || '-'
              }}</span>
            </div>
            <div v-if="orderDetail.deliveryType == 1" class="card-item">
              <span class="label">收货地址</span>
              <span class="value">{{
                orderDetail.deliveryProvince +
                  orderDetail.deliveryCity +
                  orderDetail.deliveryArea +
                  orderDetail.deliveryStreet
              }}</span>
            </div>
          </div>

          <!-- <div class="mobile-delivery-image-section">
            <h4>发货图片</h4>
            <div
              v-if="orderDetail.pubFileVoList.length > 0"
              class="mobile-images-grid"
            >
              <div
                v-for="(image, index) in orderDetail.pubFileVoList"
                :key="index"
                class="mobile-image-item"
              >
                <img
                  :src="image.fileUrl"
                  alt="发货图片"
                  class="mobile-delivery-image"
                >
              </div>
            </div>
            <div v-else class="mobile-no-images">
              <div class="mobile-no-image-placeholder">暂无更多</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api_getOrderDetail } from '@/api/index';
export default {
  name: 'OrderDetail',
  filters: {
    orderTypeFilter(val) {
      const newVal = Number(val);
      // 0-普通订单, 1-秒杀订单, 2-团购订单,3-批发订单,4-田头订单
      const map = {
        0: '普通订单',
        1: '秒杀订单',
        2: '团购订单',
        3: '批发订单',
        4: '田头订单'
      };
      return map[newVal];
    },
    orderSource(order) {
      if (order || order === 0) {
        switch (Number(order)) {
          case 0:
            return 'APP';
          case 1:
            return '小程序';
          case 2:
            return '线下订单';
          case 3:
            return '小红书订单';
          case 4:
            return '抖音订单';
          case 5:
            return '代购订单';
          default:
            return '未知订单';
        }
      }
    },
    paymentMethod(method) {
      switch (Number(method)) {
        case 1:
          return '微信';
        case 2:
          return '支付宝';
        case 3:
          return '银行卡';
        case 4:
          return '余额';
        default:
          return '其他';
      }
    },
    orderMsg(status) {
      if (status) {
        switch (status) {
          case 0:
            return '接单';
          case 1:
            return '打印';
          case 2:
            return '拣货';
          case 3:
            return '打包';
          case 4:
            return '发货';
          case 5:
            return '已发货';
          default:
            return '订单处理';
        }
      }
    }
  },
  data() {
    return {
      warehouseStatusMap: {
        0: '待接单',
        1: '待打印',
        2: '待拣货',
        3: '待打包',
        4: '待发货',
        5: '已发货'
      },
      orderStatusMap: {
        1: '待支付',
        3: '已发货',
        4: '已收货',
        5: '已完成',
        6: '已取消',
        7: '已关闭',
        8: '待退款',
        9: '拒绝退款'
      },
      orderDetail: {},
      products: [],
      deliveryImages: [],
      LcOrderLog: [],
      contractUrl:
        'https://oss.yungia.cn/yjkjoss/group1/M00/01/06/wKgBcmhcpU-AQBRrAAQm2DAHul8423.pdf'
    };
  },
  computed: {
    totalReceivables() {
      let totalPrice = 0;
      const obj = this.orderDetail;
      totalPrice =
        obj.actualAmount * 1 + obj.freightAmount * 1 + obj.deposit * 1;
      if (totalPrice) totalPrice = totalPrice.toFixed(2);
      return totalPrice;
    }
  },
  created() {
    // 获取订单ID
    const orderId = this.$route.params.id;
    // 模拟获取订单详情
    this.getOrderDetail(orderId);
  },
  methods: {
    viewContract() {
      window.open(this.contractUrl, '_blank');
    },
    goBack() {
      this.$router.back();
    },
    // 模拟获取订单详情
    async getOrderDetail(orderId) {
      // 实际项目中，这里应该调用API获取订单详情
      console.log('获取订单详情:', orderId);
      try {
        const res = await api_getOrderDetail({
          orderId: orderId
        });
        if (res && res.data) {
          this.orderDetail = res.data.lcOrder;
          // this.InvoiceInfo = this.orderDetail.orderInvoice || {};
          this.products = res.data.lcProducts;
          this.LcOrderLog = res.data.lcOrderLog;
        }
      } catch (error) {
        console.error('获取订单详情失败:', error);
      }
    }
  }
};
</script>

<style scoped>
.order-detail {
  padding: 20px;
}
.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.order-detail h2 {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.order-detail h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.order-detail h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #555;
}

.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

/* PC端表格样式 */
.pc-table {
  display: block;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.info-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.info-item .value {
  font-size: 14px;
  color: #333;
}
.info-item .link {
  color: #409eff;
  cursor: pointer;
}
/* 商品列表样式 */
.product-section {
  margin-top: 25px;
}

.pc-product-table {
  margin-top: 15px;
}

.product-table {
  width: 100%;
  font-size: 14px;
}

.product-image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

/* 费用信息样式 */
.fee-section {
  margin-top: 25px;
}

.fee-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.fee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.fee-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.fee-item .value {
  font-size: 14px;
  color: #333;
}

/* 总计样式 */
.total-section {
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 2px solid #f0f0f0;
}

.total-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.total-item .label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.total-item .value {
  font-size: 16px;
  color: #333;
  font-weight: bold;
}

.total-item.final .value {
  color: #f56c6c;
  font-size: 18px;
}

/* 物流信息样式 */
.consignee-section {
  margin-top: 25px;
}

.delivery-image-section {
  margin-top: 25px;
}

.image-container {
  margin-top: 15px;
}

.images-grid {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.image-item {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.delivery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-images {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px dashed #ddd;
}

.no-image-placeholder {
  color: #999;
  font-size: 14px;
}

/* 移动端卡片样式 */
.mobile-card {
  display: none;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
}

.card-item:last-child {
  border-bottom: none;
}

.card-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.card-item .value {
  font-size: 14px;
  color: #333;
  text-align: right;
  flex: 1;
  margin-left: 15px;
}
.card-item .link {
  color: #409eff;
  cursor: pointer;
}
/* 移动端商品卡片 */
.mobile-product-cards {
  display: none;
  gap: 15px;
  margin-top: 15px;
}

.mobile-product-card {
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px;
  gap: 12px;
}

.product-image-container {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
}

.mobile-product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}

.product-spec {
  font-size: 12px;
  color: #666;
}

.product-barcode {
  font-size: 12px;
  color: #999;
}

.product-price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  font-size: 14px;
  font-weight: bold;
}

.product-price {
  color: #f56c6c;
}

.product-quantity {
  color: #333;
}

.product-subtotal {
  color: #5470c6;
}

/* 移动端费用信息 */
.mobile-fee-section {
  /* margin-top: 15px; */
  /* padding-top: 15px; */
  /* border-top: 1px solid #f0f0f0; */
}

.mobile-fee-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.mobile-fee-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.mobile-fee-item .label {
  font-size: 12px;
  color: #666;
  text-align: center;
}

.mobile-fee-item .value {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  text-align: center;
}

/* 移动端总计 */
.mobile-total-section {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.mobile-total-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-total-item .label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.mobile-total-item .value {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.mobile-total-item.final .value {
  color: #f56c6c;
  font-size: 16px;
}

/* 移动端物流信息 */
.mobile-consignee-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.mobile-delivery-image-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.mobile-images-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 10px;
}

.mobile-image-item {
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.mobile-delivery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mobile-no-images {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px dashed #ddd;
  margin-top: 10px;
}

.mobile-no-image-placeholder {
  color: #999;
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .order-detail {
    padding: 0;
  }

  .order-detail h2 {
    font-size: 20px;
    /* margin-bottom: 15px; */
  }

  .order-detail h3 {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .order-detail h4 {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .section {
    padding: 15px;
    margin-bottom: 15px;
  }

  /* 隐藏PC端表格，显示移动端卡片 */
  .pc-table,
  .pc-product-table {
    display: none;
  }

  .mobile-card,
  .mobile-product-cards {
    display: block;
  }

  .info-grid,
  .fee-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .info-item,
  .fee-item {
    padding: 8px 12px;
  }

  .info-item .label,
  .info-item .value,
  .fee-item .label,
  .fee-item .value {
    font-size: 13px;
  }

  .total-section {
    flex-direction: column;
    gap: 15px;
    align-items: flex-end;
  }

  .total-item .label,
  .total-item .value {
    font-size: 14px;
  }

  .total-item.final .value {
    font-size: 16px;
  }

  .mobile-fee-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .mobile-images-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .order-detail {
    padding: 0;
  }

  .section {
    padding: 12px;
  }

  .card-item {
    padding: 10px 12px;
  }

  .card-item .label,
  .card-item .value {
    font-size: 13px;
  }

  .mobile-product-card {
    padding: 10px;
    gap: 10px;
  }

  .product-image-container {
    width: 70px;
    height: 70px;
  }

  .product-name {
    font-size: 13px;
  }

  .product-spec,
  .product-barcode {
    font-size: 11px;
  }

  .product-price-row {
    font-size: 13px;
  }
}
</style>
